import { Radio as MRadio } from '@mantine/core';
import classes from './radio.module.scss';

export const Radio = MRadio.extend({
  classNames: classes,
});
